module.exports = __webpack_public_path__ + "static/img/login_bg.3b46001.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/login_bg.png
// module id = ikPi
// module chunks = 1